import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { useTheme } from 'styled-components';

export const ListItemDisclosure = memo(
  ({ size, color }: { size?: number; color?: string }) => {
    const theme = useTheme();
    const { rpx } = useResponsiveContext();
    return (
      <Icon
        name="chevron-right"
        size={size ?? rpx(24)}
        color={color ?? theme.components.table.item.detailDisclosureIconColor}
      />
    );
  },
);
